import { render } from "./MiniPanel.vue?vue&type=template&id=b7ef0caa&scoped=true&ts=true"
import script from "./MiniPanel.vue?vue&type=script&lang=ts"
export * from "./MiniPanel.vue?vue&type=script&lang=ts"

import "./MiniPanel.vue?vue&type=style&index=0&id=b7ef0caa&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7ef0caa"]])

export default __exports__